import { render } from "./invitation-done.vue?vue&type=template&id=894f7758&scoped=true"
import script from "./invitation-done.vue?vue&type=script&lang=js"
export * from "./invitation-done.vue?vue&type=script&lang=js"

import "./invitation-done.vue?vue&type=style&index=0&id=894f7758&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-894f7758"]])

export default __exports__